const services = {
  header: {
    create: 'הוסף',
  },

  toast: {
    error: {
      badResponse: '[שירותים] תגובת שרת שגויה',
      create: {},
      edit: {},
    },
    success: {
      create: {
        body: 'השירות נוסף בהצלחה',
      },
      delete: {
        body: 'שירותים נמחקו בהצלחה',
      },
      edit: {},
    },
  },
  headerButtons: {
    create: 'חדש',
    delete: 'מחק',
  },
  table: {
    actions: {
      delete: 'מחק',
      export: 'ייצא',
    },
    headers: {
      maxPassengers: 'מקסימום נוסעים',
      sharedWith: 'משותף עם',
    },
    toolTip: {
      noPermission: 'Action not allowed: Permission required',
    },
  },
  create: {
    errorToast: {
      message: 'אירעה שגיאה. לא ניתן ליצור שירות',
    },
    successToast: {
      message: 'הצלחה! השירות נוצר בהצלחה',
    },
  },

  edit: {
    errorToast: {
      message: 'אירעה שגיאה. לא ניתן לעדכן שירות',
    },
    successToast: {
      message: 'הצלחה! השירות עודכן בהצלחה',
    },
  },

  delete: {
    errorToast: {
      message: 'אירעה שגיאה. לא ניתן למחוק שירות',
    },
    successToast: {
      message: 'הצלחה! השירות נמחק בהצלחה',
    },
  },

  forms: {
    header: {
      createService: {
        title: 'הוסף',
      },

      updateService: {
        title: 'עדכן',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'שמור',
        update: 'שמור',
      },
    },

    information: {
      details: {
        header: 'פרטים',
        fields: {
          name: 'שם',
          type: 'סוג',
          maxPassengers: 'מקסימום נוסעים',
          shared: 'משותף עם',
          availableCount: 'מספר רכבים',
          penaltyScore: {
            title: 'ציון קנס',
            description: 'הוצאות שכירות הרכב בהשוואה למשך הנסיעה הנוסף, נמדד בדקות.',
          },
        },
      },
      actions: {
        header: 'פעולות',
        buttons: {
          delete: 'מחק',
          resetPassword: 'איפוס סיסמה',
        },
      },
    },
  },

  serviceTypes: {
    private: 'פרטי',
    shared: 'משותף',
  },
};

export default services;
